import { SxProps, Theme } from '@mui/system';

export type SxPropsParam = SxProps<Theme>;

export function makeSxProps(sx?: SxPropsParam) {
    return  sx ? (Array.isArray(sx) ? sx : [sx]) : [];
}


